import { Grid, GridItem, RadioField, RadioInput } from '@flos/react-ui';
import {
    isAgricultureLob,
    isModifiableCancellationReason,
    shouldHideEdiChooseStatus,
    updateExternalCaseDTOProperties
} from '../../../utils/externalCasesUtil';
import { EdiCaseStatusMap } from '../steps/DatesAndCancellationStep';
import StringParagraph from './StringParagraph';
import { useRecoilState } from 'recoil';
import { externalCasesAtom } from '../../../recoil/atoms/externalCasesAtom';
import type { ExternaleCaseDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/policyjob/edi/dto/';
import type { ExternalCaseStatus_Top } from 'gw-edge-client/dist/types/dto/pc/typekey/';
import { useHippoText } from '../../../hooks/useHippoText';

export const EDICancellationChooseStatus = ({
    externalCase,
    flavourName
}: {
    externalCase: ExternaleCaseDTO;
    flavourName: string;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [externalCaseDTOList, setExternalCaseDTOList] = useRecoilState(externalCasesAtom);
    const { caseId, status, lobCode } = externalCase;
    const handleCancellationChoice = (caseId: string, statusId: string): void => {
        const updatedExternalCaseProperties = updateExternalCaseDTOProperties(
            externalCaseDTOList,
            [caseId],
            {
                status: statusId as ExternalCaseStatus_Top,
                cancellationDate: undefined,
                startDate: undefined,
                otherCompany: undefined,
                cancellationReason: undefined,
                cancellationOnExpirationDate: undefined,
                insuredIsAccountHolder: statusId !== EdiCaseStatusMap.NotRequired ? true : undefined
            }
        );
        setExternalCaseDTOList(updatedExternalCaseProperties);
    };

    if (!caseId || shouldHideEdiChooseStatus(lobCode as string)) return <></>;

    return (
        <Grid className=" u-spacing-stack-top-5" gap={6}>
            <GridItem span={8}>
                <StringParagraph>
                    {`Har du allerede en ${String(
                        flavourName
                    )?.toLowerCase()}, vi skal opsige for dig?`}
                </StringParagraph>
            </GridItem>
            <GridItem span={4}>
                <div id={`cancellationChoiceBtnGroup-${caseId}`}>
                    <RadioField
                        value={String(status)}
                        onChange={(e) => {
                            handleCancellationChoice(caseId, e.currentTarget.value);
                        }}
                        variant="button-toolbar"
                        stacked={false}
                        disabled={!isModifiableCancellationReason(externalCase.cancellationReason)}
                    >
                        <RadioInput
                            value={
                                lobCode && isAgricultureLob(lobCode)
                                    ? String(EdiCaseStatusMap.PendingCompletion)
                                    : String(EdiCaseStatusMap.ReadyForSend)
                            }
                            label={getHippoText('DSS-EFFECTIVE-DATE-AND-CANCELLATION-BUTTON-YES')}
                            defaultChecked={status === EdiCaseStatusMap.ReadyForSend}
                        />
                        <RadioInput
                            value={String(EdiCaseStatusMap.NotRequired)}
                            label={getHippoText('DSS-EFFECTIVE-DATE-AND-CANCELLATION-BUTTON-NO')}
                        />
                    </RadioField>
                </div>
            </GridItem>
        </Grid>
    );
};
